var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allCategories",class:{'content-border':_vm.showBorder}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("全部分类 "),_c('i',{staticClass:"el-icon-arrow-down"})])
}]

export { render, staticRenderFns }